import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];
const first_100 = "polygon(-16% 806.25px, 18% 229.812px, 28% 172.375px, 35% 224.812px, 22% 806.25px)";
const second_100 = "polygon(0% 806.25px, 11% 229.812px, 22% 172.375px, 34% 234.812px, 37% 806.25px)";
const third_100 = "polygon(12% 806.25px, 7% 229.812px, 18% 172.375px, 29% 234.812px, 61% 806.25px)";

const first_90 = "polygon(-16% 806.25px, 13% 229.812px, 25% 172.375px, 35.5% 224.812px, 24% 806.25px)";
const second_90 = "polygon(0% 806.25px, 11% 229.812px, 22% 172.375px, 34% 234.812px, 37% 806.25px)";
const third_90 = "polygon(14% 806.25px, 9% 229.812px, 19% 172.375px, 30% 234.812px, 55% 806.25px)";

const first_80 = "polygon(-16% 806.25px, 9% 229.812px, 23% 172.375px, 33.5% 224.812px, 24% 806.25px)";
const second_80 = "polygon(0% 806.25px, 10% 229.812px, 21% 172.375px, 33% 234.812px, 37% 806.25px)";
const third_80 = "polygon(14% 806.25px, 9% 229.812px, 21% 172.375px, 32% 234.812px, 59% 806.25px)";

const first_70 = "polygon(-16% 806.25px, 8% 229.812px, 20% 172.375px, 32% 224.812px, 22% 806.25px)";
const second_70 = "polygon(0% 806.25px, 10% 229.812px, 23% 172.375px, 35% 234.812px, 38% 806.25px)";
const third_70 = "polygon(12% 806.25px, 8% 229.812px, 21% 172.375px, 33% 234.812px, 61% 806.25px)";
const getClipPath = (height, type = 'first') => {
  // Round UP to nearest 10
  const roundedHeight = Math.round(height / 10) * 10;

  // Clamp between 70 and 100 to avoid overflow
  const clampedHeight = Math.max(70, Math.min(100, roundedHeight));
  const maxClip = type === "first" ? first_100 : type === 'second' ? second_100 : third_100;
  const clipMap = {
    70: type === "first" ? first_70 : type === 'second' ? second_70 : third_70,
    80: type === "first" ? first_80 : type === 'second' ? second_80 : third_80,
    90: type === "first" ? first_90 : type === 'second' ? second_90 : third_90,
    100: maxClip,
  };
  const selectedClipPath = clipMap[clampedHeight] || maxClip;
  return selectedClipPath
}

const main = (props) => {
  const timeouts = [];
  const { id, format, templateName, data } = props;
  const zones = props?.data?.data?.dynamic?.attackingZones;

  const timeline = anime.timeline();

  const templateDuration = 10; // for bild templates we use 5
  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );

  const video = $(`#${id} video.video-pitch`).get(0);
  if (video) {
    video.currentTime = 0;
    video.play();
  }

  anime({
    targets: [`#${id} .left-block-side`],
    rotateY: ["-50deg", 0],
    easing: "easeInOutQuad",
    duration: 1000,
    delay: 100
  })

  anime({
    targets: [`#${id} .left-block-shadow`],
    width: ["92px", "1px"],
    easing: "easeInOutQuad",
    duration: 1000,
    delay: 100
  })

  if (zones) {
    const leftZone = Math.round(zones?.leftZone);
    const centralZone = Math.round(zones?.centralZone);
    const rightZone = Math.round(zones?.rightZone);
    // const leftZone = 55;
    // const centralZone = 15;
    // const rightZone = 45;

    const leftOffset = leftZone - 39;
    // const centralOffset = centralZone - 25;
    const rightOffset = rightZone - 36;
    const rightTextBase = 835 + rightOffset / 2;

    const leftHeight = 0.4 * leftZone + 70;
    const centralHeight = 0.4 * centralZone + 70;
    const rightHeight = 0.4 * rightZone + 70;

    const leftPath = getClipPath(leftHeight, 'first');
    const centralPath = getClipPath(centralHeight, 'second');
    const rightPath = getClipPath(rightHeight, 'third');

    anime({
      targets: [`#${id} .arrow-no-one`],
      clipPath: [
        "polygon(-16% 806.25px, 0% 630.812px, 13% 548.375px, 25% 605.812px, 21% 806.25px)",
        leftPath
      ],
      height: `${leftHeight}%`,
      easing: "easeOutQuint",
      duration: 800,
      delay: 1500
    })

    anime({
      targets: [`#${id} .arrow-no-two`],
      clipPath: [
        "polygon(0% 806.25px, 12% 701.4375px, 24% 757.875px, 35% 701.4375px, 38% 806.25px)",
        centralPath,
      ],
      height: `${centralHeight}%`,
      easing: "easeOutQuint",
      duration: 800,
      delay: 1800
    })

    anime({
      targets: [`#${id} .arrow-no-three`],
      clipPath: [
        "polygon(10% 806.25px, 8.5% 500.812px, 25% 391.375px, 42% 454.812px, 67% 806.25px)",
        rightPath,
      ],
      height: `${rightHeight}%`,
      easing: "easeOutQuint",
      duration: 800,
      delay: 2200
    })


    anime({
      targets: [`#${id} #leftZone .arrow-individual`],
      easing: "easeOutQuint",
      duration: 100,
      backgroundColor: "rgba(255, 0,0, 0.9)"
    })

    anime({
      targets: [`#${id} #leftZone .arrow-no-text`],
      easing: "easeOutQuint",
      left: '10.5%',
      duration: 100,
    })

    anime({
      targets: [`#${id} #leftZone .arrow-no-text`],
      easing: "easeInOutQuad",
      scale: [0, 1],
      duration: 800,
      delay: 1900,
    })

    anime({
      targets: [`#${id} #centralZone .arrow-no-text`],
      easing: "easeOutQuint",
      left: 500,
      duration: 100,
    })

    anime({
      targets: [`#${id} #centralZone .arrow-no-text`],
      easing: "easeInOutQuad",
      scale: [0, 1],
      duration: 800,
      delay: 2200,
    })

    anime({
      targets: [`#${id} #rightZone .arrow-no-text`],
      easing: "easeOutQuint",
      left: rightTextBase,
      duration: 100,
    })
    anime({
      targets: [`#${id} #rightZone .arrow-no-text`],
      easing: "easeInOutQuad",
      scale: [0, 1],
      duration: 800,
      delay: 2500,
    })

    // anime({
    //   targets: [`#${id} #${thirdZone} .arrow-individual`],
    //   easing: "easeOutQuint",
    //   height: "60%",
    //   backgroundColor: "rgba(41, 72, 115, 0.9)",
    //   duration: 100,
    // })

  }

  anime({
    targets: [`#${id} .arrow-shadow-left`],
    opacity: [0, 1],
    easing: "easeOutQuint",
    duration: 800,
    delay: 2800
  })

  anime({
    targets: [`#${id} .arrow-shadow-central`],
    opacity: [0, 1],
    easing: "easeOutQuint",
    duration: 800,
    delay: 3000
  })

  anime({
    targets: [`#${id} .arrow-shadow-right`],
    opacity: [0, 1],
    easing: "easeOutQuint",
    duration: 800,
    delay: 3200
  })


  anime({
    targets: [`#${id} .comp-arrow-container`],
    duration: 700,
    easing: "easeOutQuint",
    translateY: [1000, 0],
    opacity: [1, 1],
    delay: anime.stagger(150),
  });

  return {
    timeline: [],
    timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
